export let hres89uColumns = () => {
  let indexColumns = [{
    key: 'dtereq',
    name: '',
    labelCodapp: 'HRES89UC1',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES89UC1',
    labelIndex: '150',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codcomp',
    name: '',
    labelCodapp: 'HRES89UC1',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codpos',
    name: '',
    labelCodapp: 'HRES89UC1',
    labelIndex: '50',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRES89UC1',
    labelIndex: '60',
    style: 'min-width: 200px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRES89UC1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRES89UC1',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'dteappr',
    name: '',
    labelCodapp: 'HRES89UC1',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'remark',
    name: '',
    labelCodapp: 'HRES89UC1',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codempap',
    name: '',
    labelCodapp: 'HRES89UC1',
    labelIndex: '110',
    style: 'min-width: 200px;'
  }]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres89u.js